export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const money = (n) => "£" + Math.round(n || 0).toLocaleString("en-GB");

export function Drawer({ children, onClose }) {
  return (
    <div className="fixed inset-0 z-50 flex justify-end" data-testid="booking-detail-drawer">
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />
      <div className="relative w-full max-w-2xl bg-white h-full overflow-y-auto p-6 md:p-8 shadow-2xl">{children}</div>
    </div>
  );
}

export function Stat({ label, value, highlight }) {
  return (
    <div className={`border p-3 ${highlight ? "border-[#C79A3B] bg-[#FBF3EC]" : "border-[#E5E7EB] bg-white"}`}>
      <div className="label-eyebrow">{label}</div>
      <div className="text-lg font-black">{value}</div>
    </div>
  );
}

export function downloadUrl(url, filename) {
  const a = document.createElement("a");
  a.href = url;
  a.download = filename || "download";
  a.target = "_blank";
  a.rel = "noreferrer";
  document.body.appendChild(a);
  a.click();
  a.remove();
}

export function printImage(url, title) {
  const w = window.open("", "_blank");
  if (!w) return;
  const doc = w.document;
  doc.title = title || "Print";
  const style = doc.createElement("style");
  style.textContent = "@media print{@page{margin:12mm}}body{margin:0;display:flex;align-items:center;justify-content:center;min-height:100vh}img{max-width:100%;max-height:100vh}";
  doc.head.appendChild(style);
  const img = doc.createElement("img");
  img.src = url;
  img.alt = title || "";
  img.onload = () => { w.focus(); setTimeout(() => w.print(), 250); };
  doc.body.appendChild(img);
}

export function ImageLightbox({ src, title, filename, onClose }) {
  if (!src) return null;
  return (
    <div data-testid="image-lightbox" className="fixed inset-0 z-[60] flex flex-col bg-black/85" onClick={onClose}>
      <div className="flex items-center justify-between gap-3 px-4 py-3 text-white" onClick={(e) => e.stopPropagation()}>
        <span className="text-sm font-bold tracking-wide truncate">{title}</span>
        <div className="flex items-center gap-2">
          <button data-testid="lightbox-download" onClick={() => downloadUrl(src, filename || (title || "image") + ".png")}
            className="inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-widest border border-white/30 px-3 py-1.5 hover:bg-white/10">
            Download
          </button>
          <button data-testid="lightbox-print" onClick={() => printImage(src, title)}
            className="inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-widest border border-white/30 px-3 py-1.5 hover:bg-white/10">
            Print
          </button>
          <button data-testid="lightbox-close" onClick={onClose} className="text-2xl leading-none px-2 hover:text-[#C79A3B]">&times;</button>
        </div>
      </div>
      <div className="flex-1 flex items-center justify-center p-4 overflow-auto" onClick={onClose}>
        <img src={src} alt={title} onClick={(e) => e.stopPropagation()} className="max-w-full max-h-full object-contain bg-white" />
      </div>
    </div>
  );
}
